import { render, staticRenderFns } from "./app-detail-time-axis-official-card.vue?vue&type=template&id=12a1b411&"
import script from "./app-detail-time-axis-official-card.vue?vue&type=script&lang=js&"
export * from "./app-detail-time-axis-official-card.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-time-axis-official-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports